<template>
	<div class="login-container" v-if="pageType == 'login'">
		<!-- 登录表单 -->
		<el-form class="login-box">
			<div class="login-tips" v-if="isOpenLoginLimit">商家设置了查看权限，请先登录账号验证身份</div>
			<div class="login-title">账号登录</div>
			<!-- 账号密码登录 -->
			<div v-show="loginType == 'pwd'">
				<el-form-item class="login-item">
					<el-input v-model="loginName" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item class="login-item" style="text-align: right;">
					<el-input v-model="loginPwd" placeholder="请输入密码" show-password></el-input>
					<el-button type="text" @click="forgetPwd">忘记密码？</el-button>
				</el-form-item>
				<el-form-item class="login-item">
					<el-button class="btn-login" type="danger" @click="loginByPwd" :loading="loginClicked">登
						录</el-button>
				</el-form-item>
				<el-form-item class="login-item" style="margin-top: 10px;">
					<el-button class="btn-login btn-change-type" @click="loginType = 'tel';forgetClicked = false;">使用手机号登录</el-button>
				</el-form-item>
			</div>
			<!-- 手机号验证码登录 -->
			<div v-show="loginType == 'tel'">
				<el-form-item class="login-item">
					<el-input v-model="loginTel" onkeyup="value=value.replace(/[^\d | ^+]/g,'')" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item class="login-item">
					<el-input class="input-vcode" v-model="loginCode" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入验证码"></el-input>
					<el-button class="btn-vcode" type="danger" @click="getVerificationCode">{{vcodeBtnTxt}}</el-button>
				</el-form-item>
				<el-form-item class="login-item" style="margin-top: 60px;">
					<el-button class="btn-login" type="danger" @click="loginCheck" :loading="loginClicked">登
						录</el-button>
				</el-form-item>
				<el-form-item class="login-item" style="margin-top: 10px;">
					<el-button class="btn-login btn-change-type" @click="loginType = 'pwd';forgetClicked = false;">使用用户名密码登录</el-button>
				</el-form-item>
			</div>
		</el-form>
		<!-- 完善用户名密码信息弹窗 -->
		<name-pwd-dialog :isShow="showCompleteInfo" :oldName="oldLoginName" @success="completeSuccess"></name-pwd-dialog>

		<!-- 网站备案 -->
		<div class="footer">
			<p class="footer-txt">
				{{copyright||"版权所有(C) 2017-现在 杭州吉客云网络技术有限公司"}}&nbsp;
				<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
					{{ICPNNumber||"浙ICP备18019426号-1"}}
				</a>
			</p>
			<p class="footer-txt" v-if="isShowCybersecuritycNumber">
				<img src="../../assets/images/icon-police.png" alt="">
				<a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014798" target="_blank" rel="noopener noreferrer">
					{{cybersecuritycNumber||"浙公网安备 33011002014798 号"}}&nbsp;&nbsp;</a>
				<a data-v-b6ac6d7e="" href="https://new.cnzz.com/v1/login.php?siteid=1279031780" target="_blank" rel="noopener noreferrer"> 站长统计 </a>
			</p>
		</div>
	</div>
	<div v-else>
		<checkin-apply formHeight='540px'></checkin-apply>
	</div>

</template>

<script>
	import NamePwdDialog from '../../components/common/NamePwdDialog.vue';
	import CheckInApply from '../../components/common/CheckInApply.vue';
	import { getCustomerInfo, registeCustomer } from '../../utils/api-utils/api-customer.js';
	import { getParam } from '../../utils/api-utils/api-params.js';
	import commonUtil from '../../utils/common-utlis.js';
	import { system } from '../../utils/api-utils/api-sys.js';
	import '../../theme/element/theme/self.css'
	var interval;
	export default {
		name: 'Login',
		components: {
			'name-pwd-dialog': NamePwdDialog,
			'checkin-apply': CheckInApply,
		},
		data() {
			return {
				loginTel: "", // 用户输入的手机号
				loginCode: "", // 用户输入的验证码
				loginPhone: "", // 用户输入的手机号
				loginPassword: "", // 用户输入的密码
				sysLoginCode: "", // 系统发送的验证码，用作校验
				vcodeBtnTxt: "获取验证码", // 获取验证码按钮文字
				vcodeIntervalTime: 60, // 验证码发送间隔 
				loginClicked: false, // 按钮已点击
				loginType: "pwd", // 登录方式 tel:手机号验证码, pwd:登录名密码
				loginName: "", //登录名
				loginPwd: "", //登录密码
				showCompleteInfo: false, //完善信息弹窗（用户名密码）
				forgetClicked: false, //点击了忘记密码
				oldLoginName: "", //原登录名
				restrictLoginText: "仅限指定会员登录，请联系商家开通",
				isOpenLoginLimit: false,
				pageType: 'login',
				loginLimitApplySettingList: [],
				copyright: "", // 版权
				ICPNNumber: "", // 备案号
				cybersecuritycNumber: "", //网安备案号
				isShowCybersecuritycNumber: true, // 是否显示公安备案
				customerInfo: {}
			}
		},
		created: function() {
			this.loadParam(); // 获取参数
		},
		methods: {
			/**
			 * 获取验证码
			 */
			getVerificationCode() {
				let _this = this;

				//关闭所有警告
				_this.$message.closeAll();

				// 检测是否可以再次获取验证码
				if (_this.vcodeBtnTxt != "获取验证码") {
					return false;
				}

				// 检测验证码输入是否正确
				if (!_this.loginTel) {
					return _this.$message.error('请输入手机号');
				}

				// 检测手机号格式是否正确
				if (!_this.$utils.checkTel(_this.loginTel)) {
					return _this.$message.error('手机号格式不正确');
				}

				// 发送请求获取验证码
				_this.$request.jackyunPost({
					method: "jmall.sms.sendverificationcode",
					jsonStr: JSON.stringify({
						loginTel: _this.loginTel,
					})
				}, (data) => {
					// 检测验证码发送是否正确
					if (data.code != 200) {
						return _this.$message.error(data.msg);
					}

					// 开始倒计时
					_this.countdown();

				});
			},

			/**
			 * 倒计时
			 */
			countdown() {
				let _this = this;
				interval = setInterval(function() {
					_this.vcodeBtnTxt = _this.vcodeIntervalTime + "秒";
					_this.vcodeIntervalTime = _this.vcodeIntervalTime - 1;
					if (_this.vcodeIntervalTime < 0) {
						_this.vcodeBtnTxt = "获取验证码";
						_this.vcodeIntervalTime = 60;
						clearInterval(interval);
					}
				}, 1000);
			},

			/**
			 * 登录验证
			 */
			async loginCheck() {
				let _this = this;

				//关闭所有警告
				_this.$message.closeAll();

				// 检测手机号是否输入
				if (!_this.loginTel) {
					return _this.$message.error('请输入手机号');
				}

				// 检测手机号格式是否正确
				if (!_this.$utils.checkTel(_this.loginTel)) {
					return _this.$message.error('手机号格式不正确');
				}

				// 检测验证码输入是否正确
				if (!_this.loginCode) {
					return _this.$message.error('请输入验证码');
				}

				// 获取用户信息
				_this._getCustomerInfoByTel();
			},

			/**
			 * 获取用户信息
			 */
			async _getCustomerInfoByTel() {
				let _this = this;
				if (_this.loginClicked) {
					return _this.$message.error('请勿重复点击');
				}

				// 显示加载中弹窗
				commonUtil.showLoading(_this, '登录中');
				_this.loginClicked = true;

				// 清除customerid缓存
				localStorage.removeItem("pc_customerId");
				localStorage.removeItem("pc_lastLoginDistributorId");

				// 手机号登录
				let customer = await getCustomerInfo({ tel: _this.loginTel, verificationCode: _this.loginCode }, true);

				// 关闭加载中弹窗
				commonUtil.closeLoading();
				_this.loginClicked = false;

				// 登录失败
				if (!customer.phone || customer.error) {
					// 是否需要注册
					let needRegister = customer.error.includes("根据手机号未查到客户信息") || customer.error.includes("未获取到crm客户档案");

					// 接口参数 
					let needHandleLoginLimit = _this.isOpenLoginLimit && ['auditLimitOfCheckIn', 'auditLimitOfPrice'].includes(_this.loginLimitType);

					customer = needRegister ? await registeCustomer(this.loginTel, needHandleLoginLimit) : customer;

					return customer.error.includes('需要申请') && needHandleLoginLimit ? _this.handleLoginLimit() : _this.openAlterMessageBox(customer.errorTip || customer.error);
				}

				// 判断是否有用户名密码，没有的话，提示设置（忘记密码也需要弹窗重置）
				if (!customer.loginName || this.forgetClicked) {
					this.oldLoginName = customer.loginName;
					this.showCompleteInfo = true;
					return 
				} 
				
				this.customerInfo = customer
				this.completeSuccess()
			},

			/**
			 * 限制登录相关处理
			 */
			handleLoginLimit() {
				// 记录手机号
				localStorage.setItem("telForRegister", this.loginTel);

				// 不允许进入商城：展示申请表单； 不允许查看价格：跳转首页
				if (this.loginLimitType == 'auditLimitOfCheckIn') {
					this.pageType = 'apply'
				} else {
					this.$router.replace({
						name: 'home'
					})
				}
			},

			/**
			 * 用户名密码登录
			 */
			loginByPwd() {
				let _this = this;

				//关闭所有警告
				_this.$message.closeAll();

				// 检测用户名是否输入
				if (!_this.loginName) {
					return _this.$message.error('请输入用户名');
				}

				// 检测密码是否输入
				if (!_this.loginPwd) {
					return _this.$message.error('请输入密码');
				}

				// 获取用户信息
				_this.getCustomerByPwd();
			},

			/**
			 * 根据用户名密码，获取用户信息
			 */
			async getCustomerByPwd() {
				let _this = this;
				if (_this.loginClicked) {
					return _this.$message.error('请勿重复点击');
				}
				// 显示加载中弹窗
				commonUtil.showLoading(_this, '登录中');
				_this.loginClicked = true;

				// 清除customerid缓存
				localStorage.removeItem("pc_customerId");
				localStorage.removeItem("pc_lastLoginDistributorId");

				//用户名密码登录
				let customer = await getCustomerInfo({ loginName: _this.loginName, loginPwd: btoa(encodeURIComponent(_this.loginPwd)) }, true)
				
				// 关闭加载中弹窗
				commonUtil.closeLoading();
				_this.loginClicked = false;

				// 登录失败
				if (!customer.phone || customer.error) {
					// 是否需要展示 申请表单
					let needHandleLoginLimit = customer.error.includes("需要申请") && _this.isOpenLoginLimit && ['auditLimitOfCheckIn', 'auditLimitOfPrice'].includes(_this.loginLimitType);

					return needHandleLoginLimit ? _this.handleLoginLimit() : _this.openAlterMessageBox(customer.errorTip || customer.error);
				}

				/* if (!customer.customerId) {
					return _this.openAlterMessageBox(customer.error);
				} */

				this.customerInfo = customer
				this.completeSuccess()
			},

			/**
			 * 用户名密码设置完成
			 */
			completeSuccess() {
				system.setCustomerId(this.customerInfo.customerId)
				
				const channel = new BroadcastChannel("jmall-memberName");
				channel.postMessage(this.customerInfo.customerId);
				channel.close();
				
				// 跳转到首页
				this.$router.replace({
					name: 'home'
				})
			},

			/**
			 * 加载参数
			 */
			async loadParam() {
				let params = await getParam("pc_restrictLoginText,isOpenLoginLimit,loginLimitType,domainFiling");
				if (!!params.pc_restrictLoginText) {
					this.restrictLoginText = params.pc_restrictLoginText.replaceAll('\n', '<br>');
				}

				// 自定义备案信息
				var domainFiling = params.domainFiling;
				if (domainFiling) {
					try {
						var domainFilingList = domainFiling.split(',');
						this.copyright = (domainFilingList[0] || "").trim().replace("2017-2020", "2017-现在");
						this.ICPNNumber = (domainFilingList[1] || "").trim();
						this.cybersecuritycNumber = (domainFilingList[2] || "").trim();
						this.isShowCybersecuritycNumber = !!this.cybersecuritycNumber;
					} catch (e) {}
				}

				this.isOpenLoginLimit = params.isOpenLoginLimit == '1';
				this.loginLimitType = params.loginLimitType;
			},

			/**
			 * 忘记密码（先用手机号登录，再设置密码）
			 */
			forgetPwd() {
				this.loginType = 'tel';
				this.forgetClicked = true;
			},

			// 打开限制登入弹窗
			openAlterMessageBox(text) {
				this.$message.error(text);
			}
		}
	}
</script>

<style scoped="scoped">
	.login-box {
		padding: 30px 50px;
		width: 400px;
		margin: 50px auto 0;
	}

	.login-tips {
		text-align: center;
		color: #999;
		font-size: 16px;
	}

	.login-title {
		text-align: center;
		font-size: 26px;
		margin-top: 30px;
		margin-bottom: 50px;
	}

	.login-item {
		margin-bottom: 20px;
	}

	.input-vcode {
		width: 278px;
	}

	.btn-vcode {
		margin-left: 10px;
		width: 112px;
	}

	.btn-login {
		width: 100%;
	}

	.btn-change-type {
		border: 1px solid #f56c6c;
		color: #f56c6c;
	}

	.footer {
		position: fixed;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}

	.footer-txt {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		color: #333;
		font-size: 13px;
	}

	/deep/.el-tabs__item {
		padding-left: 68px !important;
		padding-right: 68px !important;
		margin-bottom: 8px !important;
	}

	/deep/.el-tabs__content {
		margin-top: 30px !important;
	}
</style>